import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const ToastError: React.FunctionComponent<Props> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      aria-label='Error'
      viewBox='0 0 24 24'>
      <circle
        cx='12'
        cy='12'
        r='12'
        fill='var(--color-error)'
      />
      <rect
        width='2'
        height='10.5'
        x='11'
        y='5.5'
        fill='var(--color-white)'
        rx='1'
      />
      <rect
        width='2'
        height='2'
        x='11'
        y='17.5'
        fill='var(--color-white)'
        rx='1'
      />
    </svg>
  );
};

export default ToastError;
